import { useCallback } from 'react';
import { toast } from 'react-toastify';
import { useAuth } from '../context/authContext';
import useHttp from './useHttp';

// Encapsulates the Copago article CSV import. The raw CSV text is sent to the
// backend which parses it, upserts articles by copagoId and (optionally)
// deactivates articles missing from the upload.
const useCopagoArticleImport = () => {
  const auth = useAuth();
  const { isLoading, error, sendRequest } = useHttp();

  const importArticles = useCallback(
    async ({ csv, deactivateMissing = true, dryRun = false }) => {
      try {
        return await sendRequest({
          url: '/api/v1/copagoArticle/import',
          method: 'POST',
          headers: auth.getAuthHeaders(),
          body: { csv, deactivateMissing, dryRun },
        });
      } catch (err) {
        toast.error('Fehler beim Importieren der Copago-Artikel');
        throw err;
      }
    },
    [auth, sendRequest]
  );

  return { isLoading, error, importArticles };
};

export default useCopagoArticleImport;
